/**
 * Returns the Rails CSRF token from the `csrf-token` meta tag rendered by
 * `csrf_meta_tags` in `application.html.erb`.
 *
 * Use this hook only when Inertia isn't in the flow — Inertia's bundled Axios
 * reads the `XSRF-TOKEN` cookie automatically, so `useForm`/`router.*` callers
 * never need it. Read the DOM on each call to avoid extra re-renders from state.
 */
export const useCsrfToken = (): string => {
  if (typeof document === "undefined") {
    return "";
  }

  // biome-ignore lint/plugin/no-direct-csrf-token-read: canonical reader — all other callers must use this hook
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "";
};
